import React, { Component } from 'react';
import {Link} from 'react-router-dom';

//import '../../index.scss';

import {svgFactory } from '../../api/svgFactory';

class SVGLinkCollection extends Component {

    render () {
        const { item } = this.props;
        return (
            <div className={item.class}>
                <section className="service section-b-space border-section border-top-0">
                    <div className="title1 title5">
                        {item.subtitle && <h4>{item.subtitle}</h4>}
                        {item.title && <h3 className="title-inner1">{item.title}</h3>}
                        {item.title && <hr gadget="tournament6" />}
                    </div>
                    <div className="row partition4">
                        { item.items.map((childItem ) => 
                            <div className="col-lg-3 col-md-6 service-block1">
                                <Link to={`${process.env.PUBLIC_URL}${childItem.link}`}>
                                    <div dangerouslySetInnerHTML={{ __html: svgFactory[childItem.svgName] }} />
                                    <h4>{childItem.name}</h4>
                                    <p>{childItem.detail}</p>
                                </Link>                            
                            </div>
                        )}           
                    </div>
                </section>
            </div>
        )
    }
}

export default SVGLinkCollection;